import React, { useState, useEffect, useContext } from "react";
import styled, { keyframes } from "styled-components";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles, withStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import Edit from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import UserService from "services/UserService";
import { getAccountContracts } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import CustomDialog from "components/CustomDialog/CustomDialog.js";
import useActionTable from "./useActionTable.js";
import EditMeterDialog from "./EditMeterDialog";
import { energyType, targetedenergyList } from "variables/lists/action";
import { action } from "variables/action";

import { compte } from "variables/patrimoine.js";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const Container = styled.div`
  background-color: #f5f5f5;
  display: flex;
  flex-direction: row;
  padding: 0.8rem 0rem 0.2rem;
`;

const ContainerTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  font-family: "Source Sans Pro", sans-serif;
  margin-bottom: 0.3rem;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  //margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: ${(props) => props.marginleft};
`;
const ElementTContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const ElementTitle = styled.div`
  margin-right: 1.2rem;
  font-size: 13px;
  font-family: "Source Sans Pro", sans-serif;
  opacity: 0.85;
`;
const ElementTitleLast = styled.div`
  font-size: 13px;
  font-family: "Source Sans Pro", sans-serif;
  opacity: 0.85;
`;

const ElementData = styled.div`
  font-weight: 600;
  font-size: 13.2px;
  font-family: "Source Sans Pro", sans-serif;
  text-align-last: right;
  color: ${(props) => colorToFetch(props.number)};
`;

const colorToFetch = (number) => {
  if (Math.sign(number) == 1) {
    return "#91C73C";
  } else if (Math.sign(number) == -1) {
    return "#ff432d";
  } else {
    return "#000";
  }
};

const fontweightToFetch = (number) => {
  if (Math.sign(number) == 1) {
    return "600";
  } else if (Math.sign(number) == -1) {
    return "400";
  } else {
    return "400";
  }
};

const HelperText = styled.div`
  font-size: 13px;
  font-family: "Source Sans Pro", sans-serif;
  opacity: 0.85;
  background-color: #f5f5f5;
  display: flex;
  justify-content: flex-end;
`;

function inverseNumber(n) {
  return (n *= -1);
}

const ExpandableComponent = ({ data }) => {

  return (
    <div
      style={{
        backgroundColor: "#f5f5f5",
        padding: "0rem 4rem 1rem",
        borderTop: "4px solid rgba(231, 231, 231)",
        borderBottom: "4px solid rgba(231, 231, 231)",
      }}
    >

      <>
        <Container>
          <ExpandableContainer>
            <ContainerTitle>Compteur actuel</ContainerTitle>
            <div>
              <ExpandableElement>
                <ElementTitle>{action.impactTURPE.dcost}</ElementTitle>
                <ElementData>
                  {new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  }).format(data.details?.dcost) ?? "-"}
                </ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>{action.impactTURPE.recfta}</ElementTitle>
                <ElementData>{data.details?.fta ?? "-"} </ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>{action.impactTURPE.dataquality}</ElementTitle>
                <ElementData>{data.details?.dataquality + "%"} </ElementData>
              </ExpandableElement>
            </div>
            <div
              style={{
                boxShadow:
                  "rgb(0 0 0 / 2%) 0px 1px 3px 0px, rgb(27 31 35 / 15%) 0px 0px 0px 1px",
                borderRadius: "6px",
                padding: "3px 15px",
                marginTop: ".6rem",
              }}
            >
              <ElementTContainer>
                <div style={{ marginRight: "1rem" }}>
                  <ExpandableElement>
                    <ElementTitle>&nbsp;</ElementTitle>
                  </ExpandableElement>
                  {(data.details?.segment.toLowerCase() == "c3" ||
                    data.details?.segment.toLowerCase() == "c2") && (
                      <>
                        <ExpandableElement>
                          <ElementTitle>Pointe </ElementTitle>
                        </ExpandableElement>
                      </>
                    )}
                  {data.details?.segment.toLowerCase() !== "c5" && (
                    <><ExpandableElement>
                      <ElementTitle>HPH </ElementTitle>
                    </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>HCH </ElementTitle>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>HPE </ElementTitle>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>HCE </ElementTitle>
                      </ExpandableElement> </>
                  )}

                  {" "}
                  <ExpandableElement>
                    <ElementTitle>P </ElementTitle>
                  </ExpandableElement>
                </div>
                <div style={{ marginRight: "1rem" }}>
                  <ElementTitleLast>PS </ElementTitleLast>
                  {(data.details?.segment.toLowerCase() == "c3" ||
                    data.details?.segment.toLowerCase() == "c2") && (
                      <>
                        <ElementData>{data.details?.pspte ?? "-"}</ElementData>
                      </>
                    )}
                  {data.details?.segment.toLowerCase() !== "c5" && (
                    <>
                      <ElementData>{data.details?.pshph ?? "-"}</ElementData>
                      <ElementData>{data.details?.pshch ?? "-"}</ElementData>
                      <ElementData>{data.details?.pshpe ?? "-"}</ElementData>
                      <ElementData>{data.details?.pshce ?? "-"}</ElementData>
                    </>
                  )}


                  <ElementData>{data.details?.psmax ?? "-"}</ElementData>
                </div>
                <div style={{ marginRight: "1rem" }}>
                  <ElementTitleLast>PMax </ElementTitleLast>
                  {(data.details?.segment.toLowerCase() == "c3" ||
                    data.details?.segment.toLowerCase() == "c2") && (
                      <>
                        <ElementData>{data.details?.pmaxpte ?? "-"}</ElementData>
                      </>
                    )}
                  {data.details?.segment.toLowerCase() !== "c5" && (
                    <>
                      <ElementData>{data.details?.pmaxhph ?? "-"}</ElementData>
                      <ElementData>{data.details?.pmaxhch ?? "-"}</ElementData>
                      <ElementData>{data.details?.pmaxhpe ?? "-"}</ElementData>
                      <ElementData>{data.details?.pmaxhce ?? "-"}</ElementData>
                    </>
                  )}

                  <ElementData>{data.details?.pmax ?? "-"} </ElementData>
                </div>
                <div>
                  <ElementTitleLast>Conso. </ElementTitleLast>
                  {(data.details?.segment.toLowerCase() == "c3" ||
                    data.details?.segment.toLowerCase() == "c2") && (
                      <>
                        <ElementData>{data.details?.eapte ?? "-"}</ElementData>
                      </>
                    )}
                  {data.details?.segment.toLowerCase() !== "c5" && (
                    <>
                      <ElementData>{data.details?.eahph ?? "-"}</ElementData>
                      <ElementData>{data.details?.eahch ?? "-"}</ElementData>
                      <ElementData>{data.details?.eahpe ?? "-"}</ElementData>
                      <ElementData>{data.details?.eahce ?? "-"}</ElementData>
                    </>
                  )}


                  <ElementData>-</ElementData>
                </div>
              </ElementTContainer>
            </div>
          </ExpandableContainer>
          <Divider
            orientation="vertical"
            flexItem
            style={{ margin: "0rem 3rem" }}
          />

          <ExpandableContainer>
            <ContainerTitle>Compteur optimisé</ContainerTitle>
            <div>
              <ExpandableElement>
                <ElementTitle>Marge </ElementTitle>
                <ElementData>
                  {((data.details?.margin - 1) * 100 || 0).toFixed(0)}%
                </ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>{action.impactTURPE.recfta} </ElementTitle>
                <ElementData>{data.details?.recfta ?? "-"}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>&nbsp;</ElementTitle>
                <ElementData>&nbsp;</ElementData>
              </ExpandableElement>
            </div>
            <div
              style={{
                boxShadow:
                  "rgb(0 0 0 / 2%) 0px 1px 3px 0px, rgb(27 31 35 / 15%) 0px 0px 0px 1px",
                borderRadius: "6px",
                padding: "3px 15px",
                marginTop: ".6rem",
              }}
            >
              <ElementTContainer>
                <div>
                  <ExpandableElement>
                    <ElementTitle>&nbsp;</ElementTitle>
                  </ExpandableElement>
                  {(data.details?.segment.toLowerCase() == "c3" ||
                    data.details?.segment.toLowerCase() == "c2") && (
                      <>
                        <ExpandableElement>
                          <ElementTitle>Pointe </ElementTitle>
                        </ExpandableElement>
                      </>
                    )}
                  {data.details?.segment.toLowerCase() !== "c5" && (
                    <><ExpandableElement>
                      <ElementTitle>HPH </ElementTitle>
                    </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>HCH </ElementTitle>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>HPE </ElementTitle>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>HCE </ElementTitle>
                      </ExpandableElement> </>
                  )}
                  <ExpandableElement>
                    <ElementTitle>P </ElementTitle>
                  </ExpandableElement>
                </div>
                <div>
                  <ElementTitleLast>PS</ElementTitleLast>
                  {(data.details?.segment.toLowerCase() == "c3" ||
                    data.details?.segment.toLowerCase() == "c2") && (
                      <>
                        <ElementData>{data.details?.recpspte ?? "-"}</ElementData>
                      </>
                    )}
                  {data.details?.segment.toLowerCase() !== "c5" && (
                    <>
                      <ElementData>{data.details?.recpshph ?? "-"}</ElementData>
                      <ElementData>{data.details?.recpshch ?? "-"}</ElementData>
                      <ElementData>{data.details?.recpshpe ?? "-"}</ElementData>
                      <ElementData>{data.details?.recpshce ?? "-"}</ElementData>
                    </>
                  )}
                  <ElementData>{data.details?.recps ?? "-"}</ElementData>
                </div>
              </ElementTContainer>
            </div>
          </ExpandableContainer>
          <Divider
            orientation="vertical"
            flexItem
            style={{ margin: "0rem 3rem" }}
          />
          <ExpandableContainer>
            <ContainerTitle>Coûts & Économies potentielles</ContainerTitle>
            <ElementTContainer>
              <div>
                <ExpandableElement>
                  <ElementTitle>{action.impactTURPE.ecosous} </ElementTitle>
                </ExpandableElement>
                <ExpandableElement>
                  <ElementTitle>{action.impactTURPE.ecodep} </ElementTitle>
                </ExpandableElement>
                <ExpandableElement>
                  <ElementTitle>Coût de variation PS </ElementTitle>
                </ExpandableElement>
              </div>
              <div>
                <ElementData number={data.details?.ecosous?.toString()}>
                  {new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  }).format(data.details?.ecosous) ?? "-"}
                </ElementData>
                <ElementData number={data.details?.ecodep?.toString()}>
                  {new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  }).format(data.details?.ecodep) ?? "-"}
                </ElementData>
                <ElementData
                  number={inverseNumber(data.details?.cost)?.toString()}
                >
                  {new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  }).format(data.details?.cost) ?? "-"}
                </ElementData>
              </div>
            </ElementTContainer>
            <Divider style={{ margin: "0.2rem 0rem" }} />
            <ElementTContainer>
              <div>
                <ExpandableElement>
                  <ElementTitle>{action.impactTURPE.econet} </ElementTitle>
                </ExpandableElement>
              </div>
              <div>
                <ElementData number={data.details?.econet?.toString()}>
                  {new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  }).format(data.details?.econet)}
                </ElementData>
              </div>
            </ElementTContainer>
          </ExpandableContainer>
        </Container>
        <div>
          <HelperText>*PS : Puissance souscrite</HelperText>
          <HelperText>*PMax : Puissance max atteinte</HelperText>
        </div>
      </>
    </div>
  );
};

const RTMetersPowersPerimeter = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState, refreshTable } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newData, setNewData] = useState();
  const [selectedMeter, setSelectedMeter] = useState({});

  const [open, setOpen] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);


  const columns = [
    {
      name: "N° PDL",
      selector: (row) => row.meternumber,
      sortable: true,
    },
    {
      name: "Segment",
      selector: (row) => row.details.segment,
      sortable: true,
      maxWidth: "5rem",
    },
    {
      name: "FTA",
      selector: (row) => row.details.fta,
      sortable: true,
      maxWidth: "5rem",
    },
    {
      name: "PS max",
      selector: (row) => row.details.psmax,
      sortable: true,
      maxWidth: "5rem",
    },
    {
      name: "Pmax atteinte",
      selector: (row) => row.details.pmax,
      sortable: true,
      maxWidth: "5rem",
    },
    {
      name: "Note qualité",
      selector: (row) => row.details.dataquality,
      sortable: true,
      maxWidth: "5rem",
      cell: (row) => row.details.dataquality + "%",
    },
    {
      name: "Marge de sécurité",
      selector: (row) =>
        ((row.details?.margin - 1) * 100 || 0).toFixed(0) + "%",
      sortable: true,
      maxWidth: "5rem",
    },
    {
      name: "FTA optimisée",
      selector: (row) => row.details.recfta,
      sortable: true,
      maxWidth: "5rem",
      cell: (row) =>
      row.details.recfta &&  (row.details.recfta !==  row.details.fta) ? <div style={{color:"#91C73C", fontWeight: "600"}}>{row.details.recfta}</div>
      : <div style={{color:"#000000"}}>{row.details.recfta}</div>
    },
    {
      name: "PS optimisée",
      selector: (row) => row.details.recps,
      sortable: true,
      maxWidth: "5rem",
      cell: (row) =>
      row.details.recps &&  row.details.psmax && (row.details.recps <  row.details.psmax) ? <div style={{color:"#91C73C", fontWeight: "600"}}>{row.details.recps}</div>
      : row.details.recps &&  row.details.psmax &&  (row.details.recps >  row.details.psmax) ? <div style={{color:"#ff432d"}}>{row.details.recps}</div>
      : <div style={{color:"#000000"}}>{row.details.recps}</div>
    },
    {
      name: "Economies nettes",
      selector: (row) => row.details.econet,
      sortable: true,
      cell: (row) => <div style={{color:colorToFetch(row.details.econet), fontWeight:fontweightToFetch(row.details.econet)}}>{new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
      }).format(row.details.econet)}</div>,
    },
    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <div className="actions-right">
          <Tooltip title="Editer">
            <Button
              color={"success"}
              className={classes.actionButton}
              onClick={editRow(row)}
            >
              <Edit className={classes.icon} />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const editRow = (row) => async () => {
    let obj = newData.find((o) => o.uuid === row.uuid);
   // console.log(row, newData, obj);
    setSelectedMeter(obj);
    handleClickOpen();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const contextMessage = {
    singular: "compteur",
    plural: "compteurs",
    message: "sélectionné(s)",
  };

  const rowSelectCritera = (row) => row.isSelected == true;
  const rowPreExpanded = (row) => row.meternumber == newData[0]?.meternumber;

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        //noHeader={true}
        //title="Liste des contrats fournisseurs"
        noDataComponent="Aucun compteur(s) retrouvé dans le patrimoine"
        columns={columns}
        persistTableHead
        subHeader
        expandableRows
        expandableRowsComponent={ExpandableComponent}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        //expandableRowDisabled={(row) => row.details.energy !== "electricity"}
        expandOnRowClicked
        //expandableRowExpanded={rowPreExpanded}
        pointerOnHover
        contextMessage={contextMessage}
        pagination
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Compteurs par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les compteurs",
        }}
        {...gridState}
      />
      <CustomDialog
        id="editmeterturpe"
        handleClose={handleEditClose}
        open={open}
        maxWidth="sm"
        dialogTitle="Modifier le compteur"
        dialogContent={
          <EditMeterDialog
            energy={"electricity"}
            parameters={"meters"}
            closeModal={handleEditClose}
            refetch={refreshTable}
            selectedMeter={selectedMeter}
            groupId={action.parameters.general?.groups[0]}
          />
        }
      />
    </>
  );
};

export default RTMetersPowersPerimeter;
